/* eslint-disable react/jsx-max-props-per-line */
/* eslint-disable react/jsx-sort-props */
import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import { Chip, Link as MuiLink, Stack, Typography } from '@mui/material';
import { Link } from 'react-router-dom';
import { getNsirBiReportLinks } from '../../../helpers/nsirReportAccess';
import { getNsirVencimentoUrgencyLabel } from './VencimentoStrip';
import { formatPeriodLabel } from './constants';
import { getPersonaSubtitle, getPipelineGroupLabel } from './pipelineConfig';

const ContextBar = ({
  authData,
  userRole,
  moduleConfigurations,
  persona,
  localFilter,
  activePipelineGroup,
  activeUrgency,
  onClearPipelineGroup,
  onClearUrgency,
}) => {
  const subtitle = getPersonaSubtitle(persona);
  const periodLabel = formatPeriodLabel(localFilter?.inicio, localFilter?.fim);

  const reportLinks = useMemo(
    () => getNsirBiReportLinks({ authData, userRole, moduleConfigurations }),
    [authData, userRole, moduleConfigurations],
  );

  const pipelineLabel = getPipelineGroupLabel(persona, activePipelineGroup);
  const urgencyLabel = activeUrgency ? getNsirVencimentoUrgencyLabel(activeUrgency) : null;

  const hasChips = Boolean(pipelineLabel || urgencyLabel);

  return (
    <Stack spacing={1}>
      <Stack
        direction={{ xs: 'column', sm: 'row' }}
        spacing={1}
        alignItems={{ xs: 'flex-start', sm: 'center' }}
        justifyContent="space-between"
        flexWrap="wrap"
        useFlexGap
      >
        <Stack spacing={0.25}>
          {subtitle && (
            <Typography variant="body2" color="text.secondary">
              {subtitle}
            </Typography>
          )}
          {periodLabel && (
            <Typography variant="body2" color="text.secondary">
              Período: {periodLabel}
            </Typography>
          )}
        </Stack>

        {reportLinks.length > 0 && (
          <Stack direction="row" spacing={2} flexWrap="wrap" useFlexGap>
            {reportLinks.map((item) => (
              <MuiLink
                key={item.href}
                component={Link}
                to={item.href}
                variant="body2"
                underline="hover"
              >
                {item.label} →
              </MuiLink>
            ))}
          </Stack>
        )}
      </Stack>

      {hasChips && (
        <Stack direction="row" spacing={1} flexWrap="wrap" useFlexGap>
          {pipelineLabel && (
            <Chip
              label={`Pipeline: ${pipelineLabel}`}
              size="small"
              onDelete={onClearPipelineGroup}
            />
          )}
          {urgencyLabel && (
            <Chip
              label={`Vencimento: ${urgencyLabel}`}
              size="small"
              color="warning"
              onDelete={onClearUrgency}
            />
          )}
        </Stack>
      )}
    </Stack>
  );
};

ContextBar.propTypes = {
  authData: PropTypes.object.isRequired,
  userRole: PropTypes.string.isRequired,
  moduleConfigurations: PropTypes.array,
  persona: PropTypes.string.isRequired,
  localFilter: PropTypes.object,
  activePipelineGroup: PropTypes.string,
  activeUrgency: PropTypes.string,
  onClearPipelineGroup: PropTypes.func,
  onClearUrgency: PropTypes.func,
};

ContextBar.defaultProps = {
  moduleConfigurations: [],
  localFilter: {},
  activePipelineGroup: null,
  activeUrgency: null,
  onClearPipelineGroup: null,
  onClearUrgency: null,
};

export default ContextBar;
